export default __webpack_public_path__ + "static/media/ThirdView.a2293698.jpeg";